import { Brands } from '../../../config/brands';
import mainTheme from '../theme';

const theme = {
  ...mainTheme,
  name: Brands.IEC,
  COLORS: {
    ...mainTheme.COLORS,
    primary: '#6EBBD3',
    secondary: '#270005',
  },
};

export default theme;
